const botones = document.querySelectorAll('.boton1');
const box_info = document.querySelectorAll('.boxInfo');

const btn_movil = document.querySelectorAll('.btn_movil');
const info_movil = document.querySelectorAll('.box_info');

box_info.forEach((info, index) => {
	if (index === 0) {
		info.classList.add('show');
		info.classList.remove('hide');

		// Mostrar los 2 paths del primer elemento
		let nextElement = info.nextElementSibling;
		let pathCount = 0;

		while (nextElement && pathCount < 2) {
			if (nextElement.tagName === 'path') {
				nextElement.classList.add('show');
				nextElement.classList.remove('hide');
				pathCount++;
			}
			nextElement = nextElement.nextElementSibling;
		}
	} else {
		info.classList.add('hide');
		info.classList.remove('show');

		// Ocultar los 2 paths de los demás elementos
		let nextElement = info.nextElementSibling;
		let pathCount = 0;

		while (nextElement && pathCount < 2) {
			if (nextElement.tagName === 'path') {
				nextElement.classList.add('hide');
				nextElement.classList.remove('show');
				pathCount++;
			}
			nextElement = nextElement.nextElementSibling;
		}
	}
});

botones.forEach((boton) => {
	boton.addEventListener('click', () => {
		const id = boton.dataset.info;
		const numeroBoton = id.charAt(id.length - 1); // Obtiene el último número del ID

		// Ocultar todos los boxInfo primero
		box_info.forEach((info) => {
			info.classList.remove('show');
			info.classList.add('hide');

			// Ocultar también los 2 paths que están después del boxInfo
			let nextElement = info.nextElementSibling;
			let pathCount = 0;

			while (nextElement && pathCount < 2) {
				if (nextElement.tagName === 'path') {
					nextElement.classList.remove('show');
					nextElement.classList.add('hide');
					pathCount++;
				}
				nextElement = nextElement.nextElementSibling;
			}
		});

		// Mostrar solo el boxInfo que coincide con el número del botón
		box_info.forEach((info) => {
			const numeroInfo = info.id.charAt(info.id.length - 1);

			if (numeroBoton === numeroInfo) {
				info.classList.remove('hide');
				info.classList.add('show');

				// Mostrar también los 2 paths que están después del boxInfo
				let nextElement = info.nextElementSibling;
				let pathCount = 0;

				while (nextElement && pathCount < 2) {
					if (nextElement.tagName === 'path') {
						nextElement.classList.remove('hide');
						nextElement.classList.add('show');
						pathCount++;
					}
					nextElement = nextElement.nextElementSibling;
				}

			}
		});
	});
});

/************************************/

info_movil.forEach((info, index) => {
	if (index === 0) {
		info.classList.add('show');
		info.classList.remove('hide');

		// Mostrar los 2 paths siguientes
		let next = info.nextElementSibling;
		let pathCount = 0;
		while (next && pathCount < 2) {
			if (next.tagName === 'path') {
				next.classList.add('show');
				next.classList.remove('hide');
				pathCount++;
			}
			next = next.nextElementSibling;
		}
	} else {
		info.classList.add('hide');
		info.classList.remove('show');

		let next = info.nextElementSibling;
		let pathCount = 0;
		while (next && pathCount < 2) {
			if (next.tagName === 'path') {
				next.classList.add('hide');
				next.classList.remove('show');
				pathCount++;
			}
			next = next.nextElementSibling;
		}
	}
});

// Evento al hacer clic en botones
btn_movil.forEach((boton) => {
	boton.addEventListener('click', () => {
		const id = boton.dataset.info;
		const numeroSeleccionado = id.charAt(id.length - 1);

		info_movil.forEach((info) => {
			const numeroInfo = info.id.charAt(info.id.length - 1);

			if (numeroInfo === numeroSeleccionado) {
				info.classList.add('show');
				info.classList.remove('hide');

				let next = info.nextElementSibling;
				let pathCount = 0;
				while (next && pathCount < 2) {
					if (next.tagName === 'path') {
						next.classList.add('show');
						next.classList.remove('hide');
						pathCount++;
					}
					next = next.nextElementSibling;
				}
			} else {
				info.classList.remove('show');
				info.classList.add('hide');

				let next = info.nextElementSibling;
				let pathCount = 0;
				while (next && pathCount < 2) {
					if (next.tagName === 'path') {
						next.classList.remove('show');
						next.classList.add('hide');
						pathCount++;
					}
					next = next.nextElementSibling;
				}
			}
		});
	});
});
